import { __assign, __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import { ApprovalCommentCache } from './cache';
var ApprovalModalCacheManager = (function () {
    function ApprovalModalCacheManager(options) {
        this.flowId = options.flowId;
        this.userId = options.userId;
        this.modalType = options.modalType;
        this.nodeId = options.nodeId || '';
        this.isBatchApproval = options.isBatchApproval || false;
        this.bus = options.bus;
    }
    ApprovalModalCacheManager.prototype.loadCachedComment = function () {
        return __awaiter(this, void 0, Promise, function () {
            var cached, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.flowId || !this.userId || this.isBatchApproval) {
                            return [2, null];
                        }
                        return [4, ApprovalCommentCache.get(this.flowId, this.userId, this.modalType, this.nodeId)];
                    case 1:
                        cached = _a.sent();
                        return [2, cached];
                    case 2:
                        error_1 = _a.sent();
                        console.warn('Failed to load cached approval comment:', error_1);
                        return [2, null];
                    case 3: return [2];
                }
            });
        });
    };
    ApprovalModalCacheManager.prototype.saveCachedComment = function (commentContent) {
        return __awaiter(this, void 0, Promise, function () {
            var content, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        if (!this.flowId || !this.userId || this.isBatchApproval) {
                            return [2];
                        }
                        content = commentContent;
                        if (!(!content && this.bus)) return [3, 2];
                        return [4, this.getCurrentCommentContent()];
                    case 1:
                        content = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(content && this.hasValidContent(content))) return [3, 4];
                        return [4, ApprovalCommentCache.save(this.flowId, this.userId, this.modalType, content.sourceComment, this.nodeId)];
                    case 3:
                        _a.sent();
                        return [3, 6];
                    case 4: return [4, this.clearCachedComment()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3, 8];
                    case 7:
                        error_2 = _a.sent();
                        console.warn('Failed to save cached approval comment:', error_2);
                        return [3, 8];
                    case 8: return [2];
                }
            });
        });
    };
    ApprovalModalCacheManager.prototype.clearCachedComment = function () {
        return __awaiter(this, void 0, Promise, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.flowId || !this.userId) {
                            return [2];
                        }
                        return [4, ApprovalCommentCache.clear(this.flowId, this.userId, this.modalType, this.nodeId)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.warn('Failed to clear cached approval comment:', error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    ApprovalModalCacheManager.prototype.getCurrentCommentContent = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (!_this.bus) {
                resolve(null);
                return;
            }
            _this.bus.invoke('get:mention:content', { validate: false }).then(function (mentionContent) {
                resolve({
                    sourceComment: mentionContent === null || mentionContent === void 0 ? void 0 : mentionContent.sourceComment,
                });
            }).catch(function () {
                resolve(null);
            });
        });
    };
    ApprovalModalCacheManager.prototype.hasValidContent = function (content) {
        var _a;
        if (!content)
            return false;
        var commentText = (_a = content.sourceComment) === null || _a === void 0 ? void 0 : _a.value;
        return !!(commentText && commentText.trim());
    };
    ApprovalModalCacheManager.create = function (options) {
        var _a = options.props, userId = _a.userId, flowId = _a.flowId, isBatchApproval = _a.isBatchApproval, nodeId = _a.nodeId;
        return new ApprovalModalCacheManager({
            flowId: flowId,
            userId: userId,
            modalType: options.modalType,
            nodeId: nodeId,
            isBatchApproval: isBatchApproval,
            bus: options.bus
        });
    };
    return ApprovalModalCacheManager;
}());
export { ApprovalModalCacheManager };
export function useApprovalCache(options) {
    var cacheManager = ApprovalModalCacheManager.create(options);
    return {
        loadCache: function () { return cacheManager.loadCachedComment(); },
        saveCache: function (content) { return cacheManager.saveCachedComment(content); },
        clearCache: function () { return cacheManager.clearCachedComment(); },
        getCacheManager: function () { return cacheManager; }
    };
}
export function withApprovalCache(WrappedComponent, modalType) {
    return (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.cacheManager = ApprovalModalCacheManager.create({
                props: {
                    userId: props.userId || '',
                    flowId: props.flowId || '',
                    nodeId: props.nodeId,
                    isBatchApproval: props.isBatchApproval || false
                },
                modalType: modalType,
                bus: props.bus
            });
            return _this;
        }
        class_1.prototype.render = function () {
            return React.createElement(WrappedComponent, __assign(__assign({}, this.props), { cacheManager: this.cacheManager }));
        };
        return class_1;
    }(React.Component));
}
